module.exports = __webpack_public_path__ + "media/pro/New-York-Times-logo-6381fdee.png";